import React from 'react';
import MainLayout from '../components/MainLayout';
import { Button, Col, Row as AntRow, Typography } from 'antd';
import useViewportSize from '../hooks/useViewportSize';
import cmkLogo from '../assets/CMK-logo.png'
import lamproglena from '../assets/lamproglena.jpg'
import cichlidogyrus from '../assets/cichlidogyrus.jpg'
import verrilli from '../assets/verrilli.jpg'
import ixodes from '../assets/ixodes.jpg'
import emarginata from '../assets/emarginata.jpg'
import Head from '../assets/wasp_p_header.svg';
import WaspPLogo from '../assets/wasp_p_logo.svg';
import WaspQR from '../assets/QR-WASP-P.png';
import fwoLogo from '../assets/fwo_logo.png';
import uhasseltLogo from '../assets/uhasselt-standaard.png';
import { ShareButtons } from '../components/SocialMedia';

const { Paragraph } = Typography;

const BREAKPOINT = 960;

const Row = React.forwardRef((props, ref) => (
  <AntRow ref={ref} gutter={24} {...props} />
))

const WaspPPage = () => {
  const onMobile = useViewportSize() <= BREAKPOINT;
  const mtStyle = onMobile ? { marginTop: 24 } : {};
  const flexStyle = onMobile ? { justifyContent: 'center' } : {};


  return (
    <MainLayout>
      <div className="wasp-p-page">

        <HeaderBox />


        <div className="subheader">
          <div className="subheader-section-wrapper">
            <div className="title">
              Partners & Supporters
            </div>
          </div>

          <div className="subheader-section-wrapper">
            <div>
              <img src={cmkLogo} alt={cmkLogo} id="cmk-logo" />
            </div>
            <Paragraph>
              WASP project is maintained by researchers at Centre for Environmental Sciences, UHasselt
            </Paragraph>
            <div>
              <img src={fwoLogo} alt={fwoLogo} id="cmk-logo" />
            </div>
            <div>
              <img src={uhasseltLogo} alt={uhasseltLogo} id="cmk-logo" />
            </div>
            <Paragraph>
              WASP-P received financial support from FWO-Vlaanderen (Research Foundation Flandres) and the International
              Office (DIOS) of the University of Hasselt
            </Paragraph>
          </div>
        </div>

        <div className="container">
          <div className="hr">
            <div></div>
          </div>
        </div>

        <div className="container">

          <div className="lalala">
            <Row className="how-it-works gradient" style={{ marginBottom: 64 }}>
              <Col xs={24} lg={10}>
                <div>
                  <img src={lamproglena} alt="Lamproglena monodi" />
                  <div className="photo-credits">
                    Lamproglena monodi
                  </div>
                </div>
              </Col>
              <Col xs={24} lg={14} style={mtStyle}>
                <div className="content">
                  <div className="title">
                    HOW IT WORKS
                  </div>
                  <ol>
                    <li>Answer a few demographic questions (age, gender…)</li>
                    <li>
                      <span>Observe and rate 10 parasite species images. There are no correct or wrong answers, simply let us know what YOU think.</span>
                      <Button href="https://tinyurl.com/wasp-parasite" target="_blank" rel="noreferrer"
                              className="btnn">Take the survey</Button>
                    </li>
                    <li>
                      <span>Share the survey and let others share their perception, too!</span>
                      <div className="btnn share-buttons">
                        <span>Share it: </span>
                        <ShareButtons
                          url="https://tinyurl.com/wasp-parasite"
                          title="Are parasites icky or interesting? 🪱🦠"
                        />
                      </div>
                    </li>
                  </ol>
                </div>
              </Col>


              <Col xs={24} sm={12} style={{ marginTop: 24 }}>
                <div className="content logo-container" style={flexStyle}>
                  <img src={WaspPLogo} />
                </div>
              </Col>
              <Col xs={24} sm={12}  style={{ marginTop: 24 }}>
                <div className="content qr" style={flexStyle}>
                  <div>
                    <img src={WaspQR} />
                    <a href="https://tinyurl.com/wasp-parasite" target="_blank"
                       rel="noreferrer">tinyurl.com/wasp-parasite</a>
                  </div>
                </div>
              </Col>


            </Row>


            <Row className="contribute-science">
              <Col xs={24} lg={18}>
              <div className="content">
                  <div className="title">
                    WASP-P FOR PARASITES
                  </div>
                  <Paragraph>Every species on Earth has at least one and often several species of parasites that use
                    them as hosts. Often they are specific to their host, and parasites can differ between certain
                    locations or organs on or within their host. It is estimated that more than 30% of the world's
                    parasites are on the brink of extinction by the end of this century. And yet there are less than 10
                    different species of parasites which were formally assessed for their conservation status by the
                    IUCN Red List of Threatened Species.</Paragraph>
                  <Paragraph>Actions to assess and preserve the biodiversity of wildlife parasites are urgently needed.
                    Conservation programs are more successful when they have the support of the general
                    public.</Paragraph>
                  <Paragraph>To improve communication with the public, we first need to understand how parasite species
                    are perceived. What traits make people appreciate a parasite species? Do knowledge-sharing events on
                    parasites help in viewing parasites more favorably?</Paragraph>
                  <Paragraph>To answer these questions, we developed the WASP-P (World Archives of Species Perception -
                    Parasites) project. This includes a short online survey (about 3 minutes), available in English and
                    8 other languages.</Paragraph>
                  <Paragraph>To date, WASP-P is the only scientific attempt to assess the public perception of parasite
                    species.</Paragraph>
                </div>
              </Col>
              <Col xs={24} lg={6} style={mtStyle}>
                <div>
                  <img src={cichlidogyrus} alt="Cichlidogyrus vetusmolendarius" />
                  <div className="photo-credits">
                    Cichlidogyrus vetusmolendarius
                  </div>
                </div>
              </Col>
            </Row>


            <Row className="the-wasp gradient">
              <Col xs={24} lg={10}>
                <div>
                  <img src={verrilli} alt="Acanthocotyle verrilli" />
                  <div className="photo-credits">
                    Acanthocotyle verrilli
                  </div>
                </div>
              </Col>
              <Col xs={24} lg={14} style={mtStyle}>
                <div className="content">
                  <div className="title">
                    PARASITES MATTER
                  </div>
                  <div>
                    <Paragraph className="paragraph">
                      Despite their often strongly negative connotation, parasites are crucial actors in any healthy
                      ecosystem. Not taking parasites into consideration in biodiversity policy, would amount to
                      ignoring over half of all biodiversity. These are some reasons why parasites are important:

                      <ul>
                        <li>Parasites connect consumed and consumer species.</li>
                        <li>Parasites can regulate host populations, preventing a species from becoming weedy.</li>
                        <li>Parasites can drive or hamper new habitat colonization of free-living organisms (not only
                          their hosts!).
                        </li>
                        <li>Parasites can strengthen or even drive the formation of new host species.</li>
                        <li>Parasites can be indicators and inform us on the state of the environment or of the host
                          populations.
                        </li>
                        <li>Some parasites lower the concentration of heavy metals in the host’s tissues.</li>
                        <li>Molecules extracted from parasites can be used for medical treatments (e.g. hirudin).</li>
                      </ul>


                    </Paragraph>
                  </div>
                </div>
              </Col>
            </Row>


            <Row className="about" justify="start">
              <Col xs={24} lg={14}>
                <div className="content">
                  <div className="title">
                    ABOUT US
                  </div>
                  <div>
                    <Paragraph className="paragraph">
                      The WASP Project is developed and executed by researchers from Hasselt University in Belgium,
                      specifically within the university’s Centre for Environmental Sciences (CMK).
                    </Paragraph>
                    <Paragraph className="paragraph">
                      Researchers currently involved in WASP-P are: Prof. M. Vanhove, Prof. R. Malina, Prof. N.
                      Kmentová, Dr. T. Gobbin, Tuan Nguyen.
                    </Paragraph>
                  </div>
                </div>

              </Col>
              <Col xs={24} lg={10} style={mtStyle}>
                <div>
                  <img src={ixodes} alt="ixodes scapularis" />
                  <div className="photo-credits">
                    Mouth pieces of a tick
                  </div>
                </div>
              </Col>
            </Row>


            {/*<Row className="if-this gradient">*/}
            {/*  <Col xs={24} lg={10}>*/}
            {/*    <div>*/}
            {/*      <img src={emarginata} alt="Rajonchocotyle emarginata" />*/}
            {/*      <div className="photo-credits">*/}
            {/*        Rajonchocotyle emarginata*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </Col>*/}
            {/*  <Col xs={24} lg={14} style={mtStyle}>*/}
            {/*    <div className="content">*/}
            {/*      <div className="title">*/}
            {/*        IF THIS LEFT YOU WANTING MORE*/}
            {/*      </div>*/}
            {/*      <div>*/}
            {/*        <Paragraph>*/}
            {/*          Currently, only a couple of animal parasite species are listed in the IUCN Red List. That means we*/}
            {/*          do not know how >99% of wildlife parasites are doing… are they thriving or at the edge of*/}
            {/*          extinction? Can endangered parasites still be recovered?*/}
            {/*        </Paragraph>*/}


            {/*        <Paragraph className="paragraph">*/}
            {/*          <span>In 2023, the</span> <a href="https://www.iucnparasites.com/" target="_blank"*/}
            {/*                                       rel="noreferrer">IUCN SSC Parasite Specialist Group</a> <span>was established with the aim of preserving the biodiversity of wildlife parasites (excluding parasites of humans or domesticated animals). </span>*/}
            {/*        </Paragraph>*/}
            {/*        <Paragraph className="paragraph">*/}
            {/*          <span>The Aquatic Biodiversity team at Hasselt University represents the IUCN SSC Parasite Specialist Group in Europe, with</span>*/}
            {/*          <span className="vip-name">Prof. Vanhove</span> <span> being the Steering Committee Member for Europe and </span>*/}
            {/*          <span className="vip-name">Dr. Gobbin</span> <span>being the Programme Officer. Out team, with financial support of FWO-Vlaanderen (ResearchFoundation Flandres), also developed a network including non-parasitologists to support parasite conservation and spread awareness on the ecological importance of parasites.</span>*/}
            {/*        </Paragraph>*/}
            {/*      </div>*/}
            {/*      <Button*/}
            {/*        href="https://www.uhasselt.be/en/about-hasselt-university/news/global-expert-group-conducts-research-on-how-parasites-fare-worldwide"*/}
            {/*        target="_blank" rel="noreferrer" className="btnn">Learn more</Button>*/}
            {/*    </div>*/}
            {/*  </Col>*/}
            {/*</Row>*/}


          </div>
        </div>
      </div>
    </MainLayout>
  )
};

const HeaderBox = () => (
  <div className="header-box-container">
    <div className="title">
      WORLD ARCHIVES OF SPECIES PERCEPTION - PARASITES
    </div>
    <div className="subtitle">
      Share your perception of hidden biodiversity!
    </div>
    <div className="logo-container">
      <img src={WaspPLogo} />
    </div>
    <img src={Head} alt="" />
  </div>
)

export default WaspPPage;
